import * as React from 'react'

import NextLink from 'next/link'
import styled from 'styled-components'

import * as plume from '@ulule/owl-kit-components/next'

type NavigateBackLinkProps = {
  href: string | { pathname: string; query?: Record<string, string> }
  label: string
}

export function NavigateBackLink({ href, label }: NavigateBackLinkProps): React.ReactElement {
  return (
    <plume.styles.copy.S>
      <NextLink href={href} legacyBehavior passHref locale={false}>
        <Link kind="secondary" withIcon>
          <plume.glyphs.stroke.ArrowLeft size={14} />
          {label}
        </Link>
      </NextLink>
    </plume.styles.copy.S>
  )
}

const Link = styled(plume.Link)`
  display: contents;
  width: max-content;

  ${plume.glyphs.stroke.ArrowLeft} {
    margin-right: 7px;
  }
`
